<template>
    <div class="box" v-if="assets.length">
        <div class="campaign-form-title">
            {{ customizationText('assets_step_title', 'Assets') }}
        </div>

        <p>{{ customizationText('assets_step_overview', ' Please take a look at the following assets:') }}</p>

        <div class="mt-15 mb-15">
            <div v-for="asset in assets">
                <a :href="asset.url" target="_blank">{{ asset.name }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    import CampaignCustomizeMixin from '../../../../mixins/CampaignCustomizeMixin';

    export default {
        /**
         * The component name
         *
         * @type {String}
         */
        name: 'JobAssets',

        /**
         * The component mixins
         *
         * @type {Array}
         */
        mixins: [
            CampaignCustomizeMixin
        ],

        /**
         * The component properties
         *
         * @type {Object}
         */
        props: {

            /**
             * The campaign
             */
            campaign: {
                type:     Object,
                required: true
            }
        },

        /**
         * The computed properties
         *
         * @type {object}
         */
        computed: {

            /**
             * The assets to display
             *
             * @returns {array}
             */
            assets() {
                return this.campaign.assets.filter(asset => asset.type === 'default');
            }
        }
    }
</script>

